angular.
module("dx.webapp.lists").
component("dxExamEntry", {
	templateUrl: "tmpl/lists/exam-entry-component.html",
	controller: "DxExamEntryController",
	controllerAs: "vm",
	bindings: {
		exam: "=",
		recentlyTouched: "<",
		groupTitle: "<",
		externallyManaged: "<",
	},
	require: {
		examlistCtrl: "^dxExamlist",
	},
});
